import React, { useEffect } from 'react';
import { GoArrowRight } from "react-icons/go";
import '../css/cardDanfe.css';
import { useNavigate } from "react-router-dom";


function DanfeCard({ cliente }) {
    const navigate = useNavigate();

    const handleAte30Dias = () => {
        navigate("/danfe", { state: { vlNfeAte: 30 } });
    };

    const handleAte120Dias = () => {
        navigate("/danfe", { state: { vlNfeAte: 120 } });
    };

    useEffect(() => {
        console.log('DanfeCard carregado');
    }, []);

    return (
        <div className="card danfe-card">
            <h3 className='titulo'>Danfe e XML</h3>
            {/* Container para os boletos */}
            <div className="danfe-container">
                {/* Boleto a vencer */}
                <div className="danfe">
                    <div className="danfe-info">
                        <div className="danfe-details">
                            <div className="danfe-status">
                                Até
                                <div className="danfe-value">
                                    <span>30</span>
                                </div>
                                Dias
                            </div>
                        </div>
                        <div className="danfe-link">
                            <a href="#" onClick={handleAte30Dias}>Ver <GoArrowRight /></a>
                        </div>
                    </div>
                </div>
                <div className="danfe"></div>
                <div className="danfe-info">
                    <div className="danfe-details">
                        <div className="danfe-status">
                            Até
                            <div className="danfe-value">
                                <span>120</span>
                            </div>
                            Dias
                        </div>
                    </div>
                    <div className="danfe-link">
                        <a href="#" onClick={handleAte120Dias}>Ver <GoArrowRight /></a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DanfeCard;
